const NSAPPS = 'nsapps';

export const ROUTES = {
  ROOT: '/',
  NSAPPS: `/${NSAPPS}`,
  NSAPPS_HOME: `/${NSAPPS}/nsportal-home`,
  NSAPPS_MINIAPP: `/${NSAPPS}/:route/*`,
  LOGOUT: '/logout',
  CONFIRM_ACCOUNT: '/confirm-account',
  NOT_FOUND: '*',
} as const;

export const isHomePagePath = (pathname: string): boolean => {
  return pathname === ROUTES.NSAPPS_HOME;
};
